import { Skeleton, Card } from 'antd';

export function PageLoader() {
  return (
    <div>
      <Skeleton active paragraph={{ rows: 0 }} style={{ marginBottom: 24 }} />
      <Card>
        <Skeleton active paragraph={{ rows: 8 }} />
      </Card>
    </div>
  );
}
